import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory, Link } from 'react-router'
import './tools.css'
import { isIOs, isMobile, getVideo } from '../../misc/selectors'
import { processUploadedFiles } from '../../misc/utilities'

const mapStateToProps = (state, ownProps) => {
  const { videos, me, tools } = state

  return {
    isIOs: isIOs(state),
    me,
    isMobile: isMobile(state),
    tempVideo: getVideo(videos.cache, tools.tempcode), 
  }
}

class Tool extends Component {
  fileInput = React.createRef();
  urlInput = React.createRef();

  componentDidUpdate(prevProps, prevState) {
    if (this.props.file != prevProps.file) {
      this.gotFile(this.props.file)
    }
    if (this.props.url != prevProps.url) {
      this.gotUrl(this.props.url)
    }
  }

  async gotFile(file) {
    const { me, dispatch, } = this.props

    processUploadedFiles(dispatch, [file], null, me.plan_max_length, me.plan_max_size, 'compress')
    .then(() => {
      this.formRef.reset()
    })
  }

  gotUrl(url) {

  }

  render() {
    const {dispatch, tempVideo, action } = this.props
    const self = this
    return (
      <div className="tool" style={{paddingBottom: '30px', borderBottom: '1px solid #eee'}}>
        <form 
          style={{ display: 'none' }} 
          ref={r => {
            if (r) {
              this.formRef = r
            }
          }}
        >
          <input
            id="upload-input"
            multiple={!this.props.isIOs}
            type="file"
            ref={this.fileInput}
            accept={this.props.isMobile ? "video/*" : null}
            onChange={() => {
              const files = this.fileInput.current.files
              this.gotFile(files[0])
            }}
          />
        </form>
        <div className="header">
          <div>
            <h1>Compress Video</h1>
            <p>Reduce the size of your video in seconds using this free online tool.</p>
          </div>
        </div>

        <form
          className="form start-form"
          onSubmit={(e) => {
            e.preventDefault()
            self.gotUrl(this.urlInput.current.value)
          }}
        >
          <div className="upload-pane">
            <input type="submit" style={{ visibility: 'hidden', position: 'absolute' }} />
            <button
              className="upload-button"
              onClick={(e) => {
                e.preventDefault()
                this.fileInput.current.click()
              }}
            >Select a video file</button>
            
          </div>
        </form>
        <div className="info-section">
          <p>This is a free tool from <Link to="/">Streamable</Link>, the video hosting service for online creatives that's loved by over 50 million users across the globe.</p>
          <p>It works with every file format, from MP4 video to MOV video, and is free for videos up to 10 min or 500 MB — no gimmicks, no watermarks, no sign-up required. A <Link to="/upgrade">free trial</Link> is available for larger files.</p>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Tool)
